import React, { useState } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { usePages, usePosts, useCategories } from './hooks/useBlog';
import BlogDashboard from './BlogDashboard';
import ArticleDetail from './ArticleDetail';
import SEO from '../SEO';

function Blog() {
    const [selectedItem, setSelectedItem] = useState(null);

    // API Data
    const { data: pages } = usePages();
    const { data: posts } = usePosts();
    const { data: categories } = useCategories();
    const allItems = [...(pages || []), ...(posts || [])].sort((a, b) => new Date(b.date) - new Date(a.date));

    // Dynamic SEO Metadata
    const blogTitle = selectedItem?.title?.rendered || "Latest Insights & Industry News";
    const blogDesc = selectedItem?.excerpt?.rendered?.replace(/<[^>]+>/g, '').substring(0, 160) || "Stay updated with Greenmark's latest industry news, PCM training guides, and certification insights.";

    // Navigation Handlers
    const handleNavigateHome = () => {
        setSelectedItem(null);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleSelectItem = (item) => {
        setSelectedItem(item);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="bg-surface text-on-surface font-sans selection:bg-primary-fixed selection:text-on-primary-fixed antialiased min-h-screen transition-colors duration-500">
            <SEO 
                title={blogTitle} 
                description={blogDesc} 
                ogImage={selectedItem?._embedded?.["wp:featuredmedia"]?.[0]?.source_url}
            />
            <Navbar />
            
            {/* Main Content Area with top padding for fixed Navbar if needed */}
            <main className="pt-20">
                {/* Scroll Progress Bar */}
                <div className="progress-masthead"></div>

                {selectedItem ? (
                    <ArticleDetail
                        item={selectedItem}
                        allItems={allItems}
                        categories={categories}
                        onBack={handleNavigateHome}
                        onNavigateTo={handleSelectItem}
                    />
                ) : (
                    <BlogDashboard onSelectItem={handleSelectItem} />
                )}
            </main>

            <Footer />
        </div>
    );
}

export default Blog;
